class Source {
  constructor (attrs) {
    this.id = attrs.id
    this.identityId = attrs.identityId
    this.type = attrs.type
    this.processor = attrs.processor
    this.config = attrs.config || {}
    this.raw = attrs.raw
    this.updatedAt = attrs.updatedAt
    this.lastSyncedAt = attrs.lastSyncedAt
    this.isLoading = false
    this.error = null
  }

  get needsSync () {
    if (this.type !== 'BankAccount' && this.type !== 'CustomAPI') return false
    if (!this.lastSyncedAt) return true
    const hoursSinceSync = (Date.now() - this.lastSyncedAt) / (1000 * 60 * 60)
    return hoursSinceSync > 24
  }
}

export default Source
